import { withRouter } from "react-router"
import DrawLayer from "./DrawLayer"

export default withRouter(DrawLayer)
